<div class="dashboard-cards-wrap">
	<app-dashboard-metric-card
		card="factoring.approvedCreditAssignments"
		[value]="factoringApprovedCreditAssignments | currencyLocale: CurrencyCode.Euro"
		[labelSuffix]="currentMonth?.toString()"
		[loading]="loadingFactoringApprovedCreditAssignments" />
	<app-dashboard-metric-card
		card="factoring.currentCreditAssignmentsAmount"
		[value]="factoringCurrentCreditAssignmentsAmount | currencyLocale: CurrencyCode.Euro"
		[loading]="loadingFactoringCurrentCreditAssignmentsAmount" />
	<app-dashboard-metric-card
		card="factoring.approvedAdvances"
		[value]="factoringApprovedAdvances | currencyLocale: CurrencyCode.Euro"
		[labelSuffix]="currentMonth?.toString()"
		[loading]="loadingFactoringApprovedAdvances" />
	<app-dashboard-metric-card
		card="factoring.contractDocumentPortfolioAmount"
		[value]="factoringContractDocumentPortfolioAmount | currencyLocale: CurrencyCode.Euro"
		[loading]="loadingFactoringContractDocumentPortfolioAmount" />
	<app-dashboard-metric-card
		card="factoring.contractedAmount"
		[value]="factoringContractedAmount | currencyLocale: CurrencyCode.Euro"
		[loading]="loadingFactoringContractedAmount" />
	<app-dashboard-metric-card
		card="factoring.contractAdvanceableAmount"
		[value]="factoringContractAdvanceableAmount | currencyLocale: CurrencyCode.Euro"
		[loading]="loadingFactoringContractAdvanceableAmount" />
	<app-dashboard-metric-card
		card="factoring.suppliersWithActiveContractsCompaniesCount"
		[value]="factoringSuppliersWithActiveContractsCompaniesCount"
		[loading]="loadingFactoringSuppliersWithActiveContractsCompaniesCount" />
	<app-dashboard-metric-card
		card="factoring.buyersWithActiveConnectionsCompaniesCount"
		[value]="factoringBuyersWithActiveConnectionsCompaniesCount"
		[loading]="loadingFactoringBuyersWithActiveConnectionsCompaniesCount" />
	<app-dashboard-metric-card
		card="factoring.buyersActiveConnections"
		[value]="factoringBuyersActiveConnections"
		[loading]="loadingFactoringBuyersActiveConnections" />
	<app-dashboard-metric-card
		card="factoring.pendingApprovalDocumentsAmount"
		[value]="factoringPendingApprovalDocumentsAmount"
		[loading]="loadingFactoringPendingApprovalDocumentsAmount"
		[hasAction]="canNavigate"
		(action)="navigateToFilesIntegration(FileStatus.PendingSupplierApproval)" />
</div>
